var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeacherGuide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.12 29.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1db2d7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.46,29.12H5.06A1.25,1.25,0,0,1,3.8,27.86V24.05a2.52,2.52,0,0,1,2.53-2.52H15.2a2.5,2.5,0,0,1,1.79.74l3.38-7.59a1.26,1.26,0,1,1,2.31,1L17.73,26.86v1A1.26,1.26,0,0,1,16.46,29.12ZM6.33,26.59h8.86V24.06H6.33Zm8.86-2.54h0Zm-4.43-2.52a4.44,4.44,0,1,1,4.43-4.44A4.44,4.44,0,0,1,10.76,21.53Zm0-6.34a1.9,1.9,0,1,0,1.9,1.9A1.91,1.91,0,0,0,10.76,15.19Zm17.1,5.07H22.79a1.27,1.27,0,0,1,0-2.53h3.8V2.53H2.53v15.2H5.06a1.27,1.27,0,1,1,0,2.53H1.27A1.27,1.27,0,0,1,0,19V1.27A1.27,1.27,0,0,1,1.27,0H27.86a1.26,1.26,0,0,1,1.26,1.27V19A1.26,1.26,0,0,1,27.86,20.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherGuide);
export default __webpack_public_path__ + "static/media/TeacherGuide.8981f07bf651bee37d6feb891c950c2f.svg";
export { ForwardRef as ReactComponent };